<div class="equity-heading">
  <h4 class="mt-3 mb-0">Equity Analysis</h4>
  <button class="ml-1" type="submit" cdkFocusInitial mat-flat-button color="primary" (click)="analyzeEquity()">
    Analyze Equity
  </button>
</div>

<br />
<div class="section-in-progress" *ngIf="loader">
  <mat-spinner diameter="30" class="mr-3"></mat-spinner>
  Please wait while we load
</div>
<div class="container px-3">
  <div class="row">
    <mat-card class="mb-3 mx-2" *ngFor="let data of savedEquityList">
      <mat-card-content>
        <mat-card-title class="equity-heading">
          <h4>{{ data?.name }}</h4>

          <div class="equity-actions">
            <button mat-icon-button aria-label="edit" class="edit" (click)="viewEquity(data, 'edit')">
              <i class="material-icons" matTooltip="Edit">edit</i>
            </button>

            <button mat-icon-button aria-label="delete" class="delete" (click)="deleteEquityById(data._id)">
              <i class="material-icons" matTooltip="Remove">delete</i>
            </button>
          </div>
        </mat-card-title>
        <div [matTooltip]="data?.fullAddress" matTooltipPosition="above">
          <div class="address">
            {{ data?.fullAddress }}
          </div>
        </div>

        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <mat-card-footer>
          <button mat-button color="primary" (click)="viewEquity(data, 'view')">View</button>
        </mat-card-footer>
      </mat-card-content>
    </mat-card>
    <div class="flex_center w-100" *ngIf="!loader && savedEquityList.length === 0">
      <div class="notFound text-center noData">
        <div>
          <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
          <h4>No saved equity analysis found</h4>
        </div>
      </div>
    </div>
  </div>
</div>
<mat-paginator
  [length]="totalRecords"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
  (page)="onPageChange($event)"
>
</mat-paginator>
<app-search-propety-sheet></app-search-propety-sheet>
